module.exports = __webpack_public_path__ + "static/Reiterhof1-93901d309d2885e4ca90e064c7114917.jpg";